export default {
    inline: {
        confirmSwitch: 'Discard your unsaved changes and switch language?',
        confirmDiscard: 'Discard your unsaved changes?',
        renderFailed: 'Render failed: HTTP {status}',
        notStored: 'Saved, but {n} field was not stored. | Saved, but {n} fields were not stored.',
        defaultLanguage: 'Default language',
        editLocale: 'Edit {locale}',
    },
    fields: {
        title: 'Fields on this page',
        editingLocale: 'Editing {locale}: untouched fields show {fallback}',
        scrollTo: 'Scroll to this field',
        edit: 'Edit this field',
        filled: 'Filled',
        empty: 'Empty',
        inherited: 'inherited',
        inheritedTitle: 'Not translated: shows {fallback}. Edit it to translate.',
    },
    toolbar: {
        ariaLabel: 'Editor',
        settings: 'Settings',
        form: 'form: {id}',
    },
    placeholder: {
        image: 'Click ⚙ to choose an image',
        gallery: 'Click ⚙ to add gallery items',
        slideshow: 'Click ⚙ to add slides',
        embed: 'Click ⚙ to set the embed',
    },
};
